"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function nexo(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { opacity: 0.7, d: "M8.0475 4.98713L16.0965 9.63038V14.3696L3.7905 7.26263L7.73925 4.98713C7.78713 4.95948 7.84145 4.94493 7.89675 4.94493C7.95204 4.94493 8.00636 4.95948 8.05425 4.98713", fill: color }),
        React.createElement("path", { opacity: 0.9, d: "M16.0965 4.89338L11.9963 7.26337L16.0965 9.63037V4.89338Z", fill: color }),
        React.createElement("path", { d: "M16.0964 4.89338L20.0444 7.17038C20.0941 7.19726 20.1356 7.23699 20.1646 7.28541C20.1936 7.33384 20.2091 7.38917 20.2094 7.44563V16.7374L16.0964 14.3696V4.89338Z", fill: color }),
        React.createElement("path", { opacity: 0.9, d: "M20.2013 16.7374L16.2533 19.0121C16.2049 19.0384 16.1508 19.0521 16.0958 19.0521C16.0408 19.0521 15.9866 19.0384 15.9383 19.0121L7.88928 14.3696V9.62362L20.2013 16.7374Z", fill: color }),
        React.createElement("path", { opacity: 0.6, d: "M3.7905 7.26337V16.5536C3.79068 16.6102 3.80609 16.6657 3.83513 16.7143C3.86416 16.7628 3.90574 16.8027 3.9555 16.8296L7.90425 19.1066V9.62362L3.7905 7.26337Z", fill: color }),
        React.createElement("path", { opacity: 0.7, d: "M7.89746 19.1059L11.9962 16.7374L7.89746 14.3696V19.1059Z", fill: color }));
}
exports["default"] = nexo;
//# sourceMappingURL=nexo.js.map